<div class="jit-migration-popup registration-popup">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <h2 class="text-center" id="MigrationNudgePromptLabel">{{ title }}</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
      <span class="hint-text text-center mg-btm-32">{{ body }}</span>
      <span class="hint-text text-center bonus-points" *ngIf="bonusPoints > 0">
        Get {{ bonusPoints }} bonus points when you sign in with an email code today.
      </span>
    </div>
  </div>
  <div class="row mg-top-24">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <button type="button" class="btn wb-btn-default center-block nudge-primary-cta" (click)="onSwitchNow()">
        {{ primaryCta }}
      </button>
    </div>
  </div>
  <div class="row" *ngIf="!isMandatory">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <button type="button" class="btn nudge-secondary-cta center-block" (click)="onNotYet()">
        {{ secondaryCta }}
      </button>
    </div>
  </div>
</div>
